<div class="am">
  <div class="am-head">
    <div>
      <h2 class="am-title">Manage access</h2>
      <p class="am-sub">Lock or unlock staff. Super admins and operation managers can’t be locked.</p>
    </div>
    <button type="button" class="am-x" (click)="close()" aria-label="Close">×</button>
  </div>

  <div class="am-settings" *ngIf="settings">
    <div class="am-toggle-row">
      <div class="am-toggle-info">
        <span class="am-toggle-label">Enforcement enabled</span>
        <span class="am-toggle-hint">Master switch — when off, no one is locked.</span>
      </div>
      <label class="am-switch">
        <input
          type="checkbox"
          [checked]="settings.enforcementEnabled"
          [disabled]="!!settingsBusy"
          (change)="toggleEnforcement()"
        />
        <span class="am-slider"></span>
      </label>
    </div>

    <div class="am-toggle-row">
      <div class="am-toggle-info">
        <span class="am-toggle-label">Auto-lock employees with overdue pending requests</span>
        <span class="am-toggle-hint">
          Locks any employee with a request still pending approval more than 24 hours after it was assigned, until it's approved.<ng-container
            *ngIf="!settings.enforcementEnabled"
          > Requires enforcement enabled.</ng-container>
        </span>
      </div>
      <label class="am-switch">
        <input
          type="checkbox"
          [checked]="settings.pendingRequestsRuleEnabled"
          [disabled]="!!settingsBusy"
          (change)="toggleRule()"
        />
        <span class="am-slider"></span>
      </label>
    </div>
  </div>

  <div class="am-search">
    <input type="text" placeholder="Search by name or id…" (input)="onSearch($event)" />
  </div>

  <div class="am-body">
    <div class="am-state" *ngIf="loading">Loading…</div>

    <div class="am-state am-state--error" *ngIf="error && !loading">
      Couldn’t load users.
      <button type="button" class="am-link" (click)="load()">Retry</button>
    </div>

    <div class="am-state" *ngIf="!loading && !error && !filtered.length">No users found.</div>

    <ul class="am-list" *ngIf="!loading && !error && filtered.length">
      <li class="am-row" *ngFor="let u of filtered; trackBy: trackByUser">
        <div class="am-info">
          <span class="am-name">{{ u.name }}</span>
          <span class="am-meta">{{ u.role }}<ng-container *ngIf="u.department"> · {{ u.department }}</ng-container></span>
        </div>

        <span class="am-badge" [ngClass]="statusClass(u)">{{ statusLabel(u) }}</span>

        <button
          *ngIf="u.locked; else lockBtn"
          type="button"
          class="am-btn am-btn--unlock"
          [disabled]="busyId === u.userId"
          (click)="unlock(u)"
        >{{ busyId === u.userId ? '…' : 'Unlock' }}</button>

        <ng-template #lockBtn>
          <button
            type="button"
            class="am-btn am-btn--lock"
            [disabled]="busyId === u.userId"
            (click)="lock(u)"
          >{{ busyId === u.userId ? '…' : 'Lock' }}</button>
        </ng-template>
      </li>
    </ul>
  </div>
</div>
